export enum VideoProcessingStatus {
  Pending = 'pending', // Waiting to be processed
  Uploading = 'uploading', // Currently being uploaded
  Uploaded = 'uploaded', // Upload complete
  Encoding = 'encoding', // Currently being encoded
  Encoded = 'encoded', // Chat + video OK
  Aborted = 'aborted',
}
